// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar {\n  padding: .25rem 0;\n}\n\n.sidebar button {\n  min-width: 4rem;\n  padding: .375rem .75rem;\n  margin: 0;\n}\n\n.sidebar hr {\n  border: 1px solid rgba(0,0,0,.12);\n  width: 1.5rem;\n  margin: .125rem auto;\n  opacity: 1;\n}\n\n.sidebar span.MuiTabs-indicator {\n  margin-top: .625rem;\n  left: -0.325rem;\n  width: .5rem;\n  height: 2rem !important;\n  border-radius: .25rem;\n  background-color: rgba(0,0,0,.87);\n}\n\n", ""]);
// Exports
module.exports = exports;
